<template>
  <div
    class="b1 flex flex-row gap-4 px-4 py-2
      rounded-md shadow-lg border border-gray-200 bg-white"
    :title="props.description"
  >
    <font-awesome-icon
      :icon="props.icon"
      class="text-[1.4em] text-primary text-server aspect-square my-auto"
    />
    <span
      class="my-auto text-slate-900"
    >
      <slot
        name="label"
        :label="props.label"
      >
        {{ props.label }}
      </slot>
    </span>
    <span
      :key="props.value"
      class="ml-auto my-auto text-slate-900"
    >
      <slot
        name="value"
        :value="props.value"
      >
        {{ value }}
      </slot>
    </span>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import type { Icon } from '~/utils/types'

const defaultValue = '-'

const props = defineProps<{
  icon: Icon
  label: string
  value?: any
  default?: string
  description?: string
}>()

const value = computed(() => props.value ?? props.default ?? defaultValue)
</script>
